import ApiService from "@/core/services/api.service";
import state from "./state";

export default {
  /**
   *
   * @param context
   * @param payload
   */
  assignEntitledAwayApplication(context, payload) {
    console.log(payload.name);
    context.commit("setEntitledAwayApplicationModal", payload);
  },

  /**
   * Fetch Personal Leave Application List.
   *
   * @param context
   * @returns {*}
   */
  fetchPersonalAwayApplicationList(context) {
    ApiService.setHeader();

    return ApiService.query("company/away/personal/application", {
      params: {
        "page[number]": state.pagination.current_page ?? 1,
        "page[size]": 20,
      },
    }).then((res) => {
      console.log(res);
      context.commit("setPersonalAwayApplicationList", res.data.data);
      context.commit(
        "setPersonalAwayApplicationListPagination",
        res.data.meta.pagination
      );
    });
  },
};
